import { createSlice } from '@reduxjs/toolkit';

const tableSelectionSlice = createSlice({
  name: 'tableSelectionReducer',
  initialState: {
    isExporting: false,
    triggerExport: false,
  },
  reducers: {
    setTableIsExporting: (state, action) => { state.isExporting = action.payload; },
    setTriggerExport: (state, action) => { state.triggerExport = action.payload; },
  },
});

export const { setTableIsExporting, setTriggerExport } = tableSelectionSlice.actions;
export default tableSelectionSlice.reducer;
